import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=db3235ac&scoped=true"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=db3235ac&prod&scoped=true&lang=less"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=db3235ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3235ac",
  null
  
)

export default component.exports